'use client';

import clsx from 'clsx';
import { Heading2 } from '@/components/section/headings';
import type { HomeProcessStep } from '@/constants/homeMarketing';
import { H3, P, Span, SURFACE_REVEAL } from '@/components/ui';

export type HomeProcessSectionProps = {
  title: string;
  subtitle?: string;
  steps: readonly HomeProcessStep[];
  sectionId?: string;
  className?: string;
};

/** Numbered delivery phases — horizontal on large screens, stacked on mobile. */
const HomeProcessSection: React.FC<HomeProcessSectionProps> = ({
  title,
  subtitle,
  steps,
  sectionId,
  className,
}) => (
  <section
    id={sectionId}
    className={clsx('container-section', className)}
    aria-labelledby="home-process-heading"
  >
    <div className="page-heading-wrap" id="home-process-heading">
      <Heading2
        title={title}
        subtitle={subtitle}
        titleClassName="text-prose"
        subtitleClassName="mt-3 text-prose-muted"
      />
    </div>
    <ol className="page-content-grid page-grid-4 list-none p-0">
      {steps.map((step, i) => (
        <li
          key={step.title}
          className={clsx('page-glass-panel page-glass-panel--elevated relative flex flex-col', SURFACE_REVEAL)}
        >
          <Span
            className="mb-4 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[var(--color-primary)] text-sm font-semibold text-white tabular-nums"
            aria-hidden
          >
            {i + 1}
          </Span>
          <H3 className="m-0 text-base font-semibold text-prose">{step.title}</H3>
          <P className="m-0 mt-2 flex-1 text-sm leading-relaxed text-prose-muted">{step.text}</P>
        </li>
      ))}
    </ol>
  </section>
);

export default HomeProcessSection;
